/** Valid child segments under `/reports` or `/clients/:id/reports` list (not editor). */
const REPORTS_LIST_SUB_ROUTES = [
	'create',
	'activity',
	'templates',
	'filters',
	'theme',
	'palettes',
	'branding',
] as const;

type ReportsListSubRoute = (typeof REPORTS_LIST_SUB_ROUTES)[number];

function parseUrlPathSegments(url: string): string[] {
	const pathOnly = url.split('?')[0].split('#')[0];
	return pathOnly.split('/').filter(Boolean);
}

function reportsTailSegments(segments: string[]): string[] {
	const reportsIdx = segments.indexOf('reports');
	if (reportsIdx === -1) {
		return [];
	}
	return segments.slice(reportsIdx + 1);
}

/** True when URL is on report editor/preview (not list/settings). */
export function isReportsEditorTail(tail: string[]): boolean {
	if (tail.length < 2) {
		return false;
	}
	const [first, second] = tail;
	if (REPORTS_LIST_SUB_ROUTES.includes(first as ReportsListSubRoute)) {
		return false;
	}
	return second === 'edit' || second === 'preview';
}

function resolveReportsListSubRoute(
	tail: string[]
): ReportsListSubRoute | undefined {
	if (tail.length !== 1) {
		return undefined;
	}
	const segment = tail[0];
	return REPORTS_LIST_SUB_ROUTES.includes(segment as ReportsListSubRoute)
		? (segment as ReportsListSubRoute)
		: undefined;
}

/** All Clients: navigate to global `/reports` (or preserved list sub-route). */
export function buildGlobalReportsRoute(currentUrl: string): string[] {
	const tail = reportsTailSegments(parseUrlPathSegments(currentUrl));
	if (isReportsEditorTail(tail)) {
		return ['reports'];
	}
	const subRoute = resolveReportsListSubRoute(tail);
	return subRoute ? ['reports', subRoute] : ['reports'];
}

/** Another client: navigate to `/clients/:id/reports` (or preserved list sub-route). */
export function buildClientReportsRouteOnSwitch(
	currentUrl: string,
	clientId: string
): string[] {
	const tail = reportsTailSegments(parseUrlPathSegments(currentUrl));
	if (isReportsEditorTail(tail)) {
		return ['clients', clientId, 'reports'];
	}
	const subRoute = resolveReportsListSubRoute(tail);
	return subRoute
		? ['clients', clientId, 'reports', subRoute]
		: ['clients', clientId, 'reports'];
}
